import { createStore } from '@stencil/store';
import { Application } from '../../../server/services/application/application.contractpart';
import { ApplicationQueryRequestBody } from '../../../server/services/application/query.contract';
import {
  AccountsContactQuestionQueryRequestBody
} from '../../../server/services/accounts/contact/question/query.contract';
import { Settings } from '../../../server/services/core/settings/settings.contractparts';
import { EvaluatedListFilters } from "../pages/admin/evaluated/evaluated";

const store = createStore({
  showBackdrop: false
});

export const globalState: {
  daysLeftTillStart?: number;
  daysLeftTillEnd?: number;
  isLoggedIn?: boolean;
  showBackdrop?: boolean,
  applications?: Application[]
  applicationsFilter?: ApplicationQueryRequestBody;
  questionsFilter?: AccountsContactQuestionQueryRequestBody;
  settings?: Settings;
  applicationsScrollTop?: number;
  applicationsSelectedId?: string;
  questionsScrollTop?: number;
  questionsSelectedId?: string;
  evaluatedFilters?: EvaluatedListFilters;
  evaluatedScroll?: number;
  evaluatedScrollLeft?: number;
  evaluatedSelectedRowId?: string;
  evaluatedVisibleColumns?: { [key: string]: boolean };
} = store.state;

globalState.applications = [];


export const permanentState: {
  [key: string]: any;
} = new Proxy(JSON.parse(localStorage.getItem('permanent_state') ?? '{}') as any, {
  set(target, property, value) {
    target[property as keyof typeof target] = value;
    console.log(property, ':', value);
    localStorage.setItem('permanent_state', JSON.stringify(target));
    return true;
  }
});
